export default [
  {
    component: 'CNavTitle',
    name: 'Silicon',
  },
  {
    component: 'CNavGroup',
    name: 'Campaigns',
    to: '/campaigns',
    icon: 'cil-cursor',
    items: [
      {
        component: 'CNavItem',
        name: 'Campaigns List',
        to: '/campaigns/list',
      },
      {
        component: 'CNavItem',
        name: 'Create Campaign',
        to: '/campaigns/create',
      },
      {
        component: 'CNavItem',
        name: 'Follow up',
        to: '/campaigns/follow-up',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Senders',
    to: '/senders',
    icon: 'cil-people',
    items: [
      {
        component: 'CNavItem',
        name: 'Senders List',
        to: '/senders/list',
      },
      {
        component: 'CNavItem',
        name: 'Add Sender',
        to: '/senders/add',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Templates',
    to: '/templates',
    icon: 'cil-layers',
    items: [
      {
        component: 'CNavItem',
        name: 'Templates List',
        to: '/templates/list',
      },
      {
        component: 'CNavItem',
        name: 'Add Template',
        to: '/templates/add',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Meetings',
    to: '/meetings',
    icon: 'cil-star',
    items: [
      {
        component: 'CNavItem',
        name: 'Meetings List',
        to: '/meetings/list',
      },
      {
        component: 'CNavItem',
        name: 'Report Meeting',
        to: '/meetings/report',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Replies',
    to: '/replies/add',
    icon: 'cil-comment-square',
  },
  {
    component: 'CNavItem',
    name: 'Hashids',
    to: '/hashids',
    icon: 'cil-puzzle',
  },
  {
    component: 'CNavItem',
    name: 'Docs',
    to: '/docs',
    icon: 'cil-life-ring',
  },
]
